import React from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import "./splitInfoModal.scss";
import { Col, Row } from "react-bootstrap";

function SplitInfoModal({ show, onHide, selectedTransactionEntityId }) {
  const transactionData = useSelector(
    (state) => state.order.selectedOrders.selectedTransactionData || []
  );

  const selectedTransactionDataVal = transactionData?.find(
    (val) => val.entityid === selectedTransactionEntityId
  );
  let splitInfo = [];
  let paymentResponse = null;
  let paymentStatus = "";

  if (selectedTransactionDataVal) {
    if (selectedTransactionDataVal.split_info) {
      splitInfo = selectedTransactionDataVal
        ? JSON.parse(selectedTransactionDataVal.split_info)
        : [];
    }
    paymentResponse = selectedTransactionDataVal?.payment_response
      ? JSON.parse(selectedTransactionDataVal.payment_response)
      : null;
    paymentStatus = selectedTransactionDataVal.payment_status;
  }
  const totalAmount = Number(splitInfo.reduce((acc, item) => acc + item.amount, 0).toFixed(2));

  const renderPaymentInfo = (response) => (
    <div>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Bank Reference:</span>
          </div>
          <div className="fw-bold">{response.bank_reference || "N/A"}</div>
        </Col>
        <Col md={6}>
          <div>
            <span>Payment ID:</span>
          </div>
          <div className="fw-bold">{response.cf_payment_id || "N/A"}</div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Error Code:</span>
          </div>
          <div className="fw-bold">
            {response.error_details?.error_code || "N/A"}
          </div>
        </Col>
        <Col md={6}>
          <div>
            <span>Error Description:</span>
          </div>
          <div className="fw-bold">
            {response.error_details?.error_description || "N/A"}
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Error Reason:</span>
          </div>
          <div className="fw-bold">
            {response.error_details?.error_reason || "N/A"}
          </div>
        </Col>
        <Col md={6}>
          <div>
            <span>Error Source:</span>
          </div>
          <div className="fw-bold">
            {response.error_details?.error_source || "N/A"}
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Order ID:</span>
          </div>
          <div className="fw-bold">{response.order_id || "N/A"}</div>
        </Col>
        <Col md={6}>
          <div>
            <span>Order Amount:</span>
          </div>
          <div className="fw-bold">₹{response.order_amount || "N/A"}</div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Payment Amount:</span>
          </div>
          <div className="fw-bold">₹{response.payment_amount || "N/A"}</div>
        </Col>
        <Col md={6}>
          <div>
            <span>Payment Method:</span>
          </div>
          <div className="fw-bold">{response.payment_group || "N/A"}</div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <div>
            <span>Payment Status:</span>
          </div>
          <div className="fw-bold">{response.payment_status || "N/A"}</div>
        </Col>
        <Col md={6}>
          <div>
            <span>Payment Time:</span>
          </div>
          <div className="fw-bold">{response.payment_time || "N/A"}</div>
        </Col>
      </Row>
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={onHide}
    >
      <Modal.Header
        className="p-3 bg-info-subtle"
        // style="font-size:large;font-weight:600"
        style={{ fontSize: "large" }}
        closeButton
      >
        {paymentStatus === "Failed" && paymentResponse
          ? "Payment Info"
          : "Split info "}
      </Modal.Header>
      <Modal.Body>
        {paymentStatus === "Failed" && paymentResponse ? (
          <div className="error-container">
            <div>{renderPaymentInfo(paymentResponse)}</div>
          </div>
        ) : splitInfo.length > 0 ? (
          <>
            {splitInfo.map((item, index) => (
              <>
                <div key={index} className="info-container">
                  <div>{item.merchantId}</div>
                  <div>{item.amount}</div>
                </div>
              </>
            ))}
            <div className="total-container">
              <div>
                <strong>Total</strong>
              </div>
              <div>
                {" "}
                <strong>{totalAmount}</strong>
              </div>
            </div>
          </>
        ) : (
          <p>"No info Available"</p>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SplitInfoModal;
